import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  typeOfServiceId: null,
  billingHourlyRate: null,
  employeePayRate: null,
  payrollTax: null,
  workersComp: null,
  benefits: null,
  otherCosts: null,
  state: 0,
  
  cogs: null,
  grossProfitAmount: null,
  grossProfitPercentage: null,
  status: null,
  statusColor: "#ff010"
};

const basicCalculatorSlice = createSlice({
  name: "basicCalculator",
  initialState,
  reducers: {
    updateBasicCalculator: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateState: (state, action) => {
      return {
        ...state.state,
        ...action.payload,
      };
    },
  },
});

export const { updateBasicCalculator } = basicCalculatorSlice.actions;
export default basicCalculatorSlice.reducer;
